<template>
  <div>
    <navigation />
    <topnav />
    <div class="edittask-container">
      <div>
        <button @click="startTask()">开始任务</button>
        <button class="hollow-btn" @click="deleteTask()">删除任务</button>
      </div>
      <div class="baseinfo">
        <p>
          <span>任务ID：{{ taskInfo.id }}</span>
          <span>任务名：{{ taskInfo.name }}</span>
        </p>
        <p>
          <span style="margin-right: 28px;">描述：</span>
          <input v-model="taskInfo.desc" />
        </p>
        <p>
          <span>图片ID：</span>
          <input v-model="taskInfo.imageIds" />
        </p>
        <p>
          <span>标注方式：</span>
          <select v-model="taskInfo.taskTypeId">
            <option :value="1">多边形标注</option>
            <option :value="2">矩形标注</option>
          </select>
        </p>
      </div>
      <div class="classinfo">
        <div
          v-for="c of classListFilter"
          :key="`cls${c.classId}`"
          style="display: inline-block;width: auto;margin: 0px 12px 8px 0px;"
        >
          <input
            type="checkbox"
            v-model="taskInfo.classIds"
            :value="c.classId"
            style="margin-right: 4px;vertical-align: middle;"
          />
          <span>{{ c.className }}</span>
        </div>
      </div>
      <button @click="save()" style="margin: 24px 0px 0px 0px;">保存</button>
    </div>
  </div>
</template>

<script>
import * as api from '@/api/api.js';
import navigation from '@/components/navigation';
import topnav from '@/components/topnav';

export default {
  data() {
    return {
      taskInfo: {
        imageIds: [],
      },
      taskId: null,
      userId: null,
      taskTypes: [],
      industries: [],
      taskTypeId: 0,
      industryId: 0,
      data: '',
      classifications: [],
      classList: [],
      categoryName: '',
      className: '',
      chosenClasses: [],
      shrinkCate: [],
      examList: [],
      examIds: [],
    };
  },
  components: {
    navigation,
    topnav,
  },
  computed: {
    classListFilter: function() {
      return [
        ...this.classList.filter(v => this.taskInfo.classIds.includes(v.classId)),
        ...this.classList.filter(v => !this.taskInfo.classIds.includes(v.classId)),
      ];
    },
  },
  mounted: function() {
    this.taskId = this.$route.params.id;
    this.getApproveTaskById();
  },
  methods: {
    startTask() {
      api.startApproveTask(this.taskInfo.id).then(() => {
        this.$notify({
          group: 'foo',
          text: '审核任务已开始',
          type: 'custom-blue',
          duration: 2000,
        });
      });
    },
    deleteTask() {
      if (!window.confirm(`确认删除当前审核任务吗？`)) return;
      api.deleteApproveTask(this.taskInfo.id).then(() => {
        this.$notify({
          group: 'foo',
          text: '审核任务已删除',
          type: 'custom-red',
          duration: 2000,
        });
      });
    },
    save() {
      if (typeof this.taskInfo.imageIds === 'string')
        this.taskInfo.imageIds = this.taskInfo.imageIds
          .split(',')
          .map(v => parseInt(v))
          .filter(v => v);
      api
        .updateApproveTask(this.taskInfo.id, this.taskInfo)
        .then(() => {
          this.$notify({
            group: 'foo',
            text: '保存成功',
            type: 'custom-blue',
            duration: 2000,
          });
          this.getApproveTaskById();
        })
        .catch(() => {});
    },
    getUserTotalClasses() {
      api
        .getUserTotalClasses({ userId: 11 })
        .then(res => {
          this.classList = res.data.classifications.reduce((total, item) => [...total, ...item.classes], []);
        })
        .catch(() => {});
    },
    getApproveTaskById() {
      api
        .getApproveTaskById(this.taskId)
        .then(res => {
          this.taskInfo = res.data;
          if (!this.taskInfo.classIds) this.taskInfo.classIds = [];
          this.getUserTotalClasses();
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped>
p {
  margin: 0px;
  padding: 12px 0px;
}
select {
  width: 272px;
  height: 32px;
  border: 1px solid #dddddd;
  border-radius: 4px;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  background-image: url('~@/assets/select-arrow.png');
  background-repeat: no-repeat;
  background-position: right;
  background-position-x: 250px;
  background-size: 14px;
  color: #595959;
  padding: 7px 20px 7px 12px;
  font-size: 14px;
  line-height: 100%;
  background-color: #fff;
  margin-left: 6px;
}
input {
  box-sizing: border-box;
  height: 32px;
  margin-left: 6px;
  border: 1px solid #dddddd;
  border-radius: 4px;
  font-size: 14px;
  padding: 0px 12px;
}
input[type='checkbox'] {
  width: 16px;
  height: 16px;
  margin: 0px;
  padding: 0px;
  border: none !important;
  background-size: 16px;
  background-color: #fff;
  appearance: none;
  -webkit-appearance: none;
  -o-appearance: none;
  -moz-appearance: none;
  border: 1px solid #ffad01;
  border-radius: 2px;
  outline: none;
  background-image: url('~@/assets/uncheck.png');
}
input[type='checkbox']:checked {
  background-image: url('~@/assets/checked.png');
}
input[type='checkbox']:focus {
  outline: none;
}
#image-path {
  width: 686px;
}
.baseinfo {
  background: #fafafa;
  border-radius: 4px 4px 0px 0px;
  margin: 24px 0px 12px;
  padding: 24px 36px;
  box-sizing: border-box;
  position: relative;
}
button {
  height: 36px;
  margin-right: 18px;
}
.baseinfo p span {
  display: inline-block;
  margin: 0px 12px;
}
.baseinfo p input {
  width: 70%;
}
.classinfo {
  position: relative;
  margin: 0px;
  background: #fafafa;
  border-radius: 4px 4px 0px 0px;
  padding: 24px 36px 38px;
}
.classinfo > div {
  position: relative;
  height: 100%;
  width: 100%;
}
.classinfo > div > div {
  display: inline-block;
}

.classinfo div form input {
  width: 200px;
  height: 32px;
  margin-left: 6px;
}
.classinfo div form p {
  margin: 0px 60px 23px 0px;
  display: inline-block;
}
.class-content {
  border-top: 1px dashed #bbbbbb;
}
.category-content {
  border-bottom: 1px dashed #bbbbbb;
  padding-bottom: 23px;
}
.class-content .category-content:last-child {
  border: none;
}
.class-card {
  display: inline-block;
  margin: 12px 24px 0px 0px;
  line-height: 100%;
  font-size: 14px;
  border: 1px solid #dddddd;
  border-radius: 4px;
  background: #ffffff;
}
.class-card div {
  padding: 9px 12px;
  display: inline-block;
}
.class-card .class-remove {
  padding: 9px;
  margin-top: -1px;
  /*border-left: 1px solid #dddddd;*/
}
.class-card img {
  width: 14px;
  height: 14px;
}
.chosen-classes {
  position: relative;
  vertical-align: top;
  min-height: 350px;
  width: 764px;
}
.chosen-classes button {
  margin: 0px;
}
.candidate-class {
  height: 100%;
  position: absolute;
  left: 834px;
  width: 180px;
  overflow: scroll;
}
.candidate-class > div {
  font-size: 16px;
}
.candidate-class > span {
  display: inline-block;
  font-size: 16px;
  margin: 4px 0px 24px;
}
.candidate-class > div > img {
  width: 16px;
  margin-right: 4px;
}
.shrink-arrow {
  transform: rotate(180deg);
}
.candidate-class > div > span {
  display: inline-block;
  margin-bottom: 15px;
}
.candidate-class > div > div > div {
  font-size: 14px;
  margin-bottom: 16px;
}
.candidate-class > div > div > div > span {
  vertical-align: text-top;
  display: inline-block;
  margin: -2px 0px 0px 8px;
  line-height: 16px;
}
</style>
